import config from "../config";
var axios = config();

export default {
  postCreate(studentOpportunity) {
    return axios.post("/api/pip", studentOpportunity);
  },
  postConfirm(studentOpportunity) {
    return axios.post("/api/pip/confirm", studentOpportunity);
  },
  putUpdate(studentOpportunity) {
    return axios.post("/api/pip/edit", studentOpportunity);
  }
};
